<form fxLayout="column" name="transportation-{{ transportationId }}">
  <div fxLayout="row" fxLayoutAlign="start center" style="height: 60px;">
    <p>A/R?</p>
    <span>&nbsp;&nbsp;</span>
    <span>&nbsp;&nbsp;</span>
    <mat-slide-toggle color="primary" [disabled]="disabled" [checked]="transportation.routes.length === 2"
      (change)="onARChange($event, transportation)">
      <span *ngIf="transportation.routes.length === 2">Sì</span>
      <span *ngIf="transportation.routes.length !== 2">No</span>
    </mat-slide-toggle>
  </div>

  <div [ngClass]="{ route: transportation.routes.length === 2 }" fxLayout="column" fxLayoutAlign="start start"
    *ngFor="let route of transportation.routes; index as j">
    <p class="route-label" *ngIf="transportation.routes.length === 2 && j === 0">
      Andata
    </p>
    <p class="route-label" *ngIf="transportation.routes.length === 2 && j === 1">
      Ritorno
    </p>
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Compagnia</mat-label>
        <input name="route-{{ j }}-company" matInput [(ngModel)]="route.company" type="text" required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Numero</mat-label>
        <input name="route-{{ j }}-code" matInput [(ngModel)]="route.code" type="text" required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Durata (ore)</mat-label>
        <input matInput name="route-{{ j }}-duration-hours" type="number" min="0" step="1"
          [(ngModel)]="route.duration.hours" required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Durata (minuti)</mat-label>
        <input matInput name="route-{{ j }}-duration-minutes" type="number" min="0" step="1"
          [(ngModel)]="route.duration.minutes" required />
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Da (città)</mat-label>
        <input name="route-{{ j }}-from" matInput [(ngModel)]="route.from" type="text" required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Da ({{ detailFormFieldLabel }})</mat-label>
        <input name="route-{{ j }}-fromDetail" matInput [(ngModel)]="route.fromDetail" type="text" required />
      </mat-form-field>
      <ng-container *ngIf="showCodeFormField">
        <span>&nbsp;&nbsp;</span>
        <mat-form-field appearance="outline">
          <mat-label>Da (codice)</mat-label>
          <input name="route-{{ j }}-fromCode" matInput [(ngModel)]="route.fromCode" type="text" required />
        </mat-form-field>
      </ng-container>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="date">
        <mat-label>Data partenza</mat-label>
        <input name="route-{{ j }}-start-date" matInput readonly [matDatepicker]="pickerStart" [(ngModel)]="route.start"
          (click)="pickerStart.open()" required />
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="time">
        <mat-label>Ora partenza</mat-label>
        <input type="time" name="route-{{ j }}-start-time" matInput [ngModel]="route.start?.toDate() | date: 'HH:mm'"
          (ngModelChange)="
            route.start = firestoreTimestampTimeAdapterService.getTimestamp(
              route.start,
              $event
            )
          " required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Posizione su Mappa</mat-label>
        <mat-icon matSuffix>place</mat-icon>
        <app-lat-lng-input [disabled]="disabled" [(value)]="route.fromPlace"
          [searchText]="route.from + ' ' + route.fromDetail" required></app-lat-lng-input>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>A (città)</mat-label>
        <input name="route-{{ j }}-to" matInput [(ngModel)]="route.to" type="text" required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>A ({{ detailFormFieldLabel }})</mat-label>
        <input name="route-{{ j }}-toDetail" matInput [(ngModel)]="route.toDetail" type="text" required />
      </mat-form-field>
      <ng-container *ngIf="showCodeFormField">
        <span>&nbsp;&nbsp;</span>
        <mat-form-field appearance="outline">
          <mat-label>A (codice)</mat-label>
          <input name="route-{{ j }}-toCode" matInput [(ngModel)]="route.toCode" type="text" required />
        </mat-form-field>
      </ng-container>
      <span>&nbsp;&nbsp;</span>

      <mat-form-field appearance="outline" class="date">
        <mat-label>Data arrivo</mat-label>
        <input matInput readonly name="route-{{ j }}-end-date" [matDatepicker]="pickerEnd" [(ngModel)]="route.end"
          (click)="pickerEnd.open()" required />
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="time">
        <mat-label>Ora arrivo</mat-label>
        <input type="time" name="route-{{ j }}-end-time" matInput [ngModel]="route.end?.toDate() | date: 'HH:mm'"
          (ngModelChange)="
            route.end = firestoreTimestampTimeAdapterService.getTimestamp(
              route.end,
              $event
            )
          " required />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Posizione su Mappa</mat-label>
        <mat-icon matSuffix>place</mat-icon>
        <app-lat-lng-input [disabled]="disabled" [(value)]="route.toPlace"
          [searchText]="route.to + ' ' + route.toDetail" required></app-lat-lng-input>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="outline" style="width: 1174px;">
        <mat-label>{{ stopsFormFieldLabel }}</mat-label>
        <mat-chip-list #chipList aria-label="Tappe">
          <mat-chip [disabled]="disabled" *ngFor="let stop of route.stops" [selectable]="true" [removable]="true"
            (removed)="removeStop(route, stop)">
            {{ stop }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input [disabled]="disabled" placeholder="Aggiungi..." [matChipInputFor]="chipList"
            [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addStop(route, $event)" />
        </mat-chip-list>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" style="width: 250px;">
      <mat-label>Prezzo totale per {{ npax }} persone</mat-label>
      <input name="cost" matInput [(ngModel)]="transportation.price" type="number" required />
      <mat-icon matSuffix>euro_symbol</mat-icon>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline">
      <mat-label>Partner</mat-label>
      <mat-select [(ngModel)]="transportation.partner" name="partner" [disabled]="disabled">
        <mat-option *ngFor="let affiliationPartner of affiliationPartnerData" [value]="affiliationPartner.key">
          {{ affiliationPartner.label }}
        </mat-option>
        <mat-option [value]="null">Altro</mat-option>
      </mat-select>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Link prenotazione</mat-label>
      <input name="link" matInput [(ngModel)]="transportation.link.longUrl" type="url" required />
      <app-inline-help-button matSuffix [title]="'Link prenotazione'" [content]="
          'Inserisci qui il link alla pagina di prenotazione. Controlla che il link sia funzionante copiandolo e incollandolo in una finestra di navigazione in incognito.'
        ">
      </app-inline-help-button>
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Note</mat-label>
    <textarea rows="5" name="notes" matInput [(ngModel)]="transportation.notes"></textarea>
    <app-inline-help-button matSuffix [title]="'Note'" [content]="
        'Inserisci qui un tuo commento personale che motivi i tuoi consigli e le tue scelte per quanto riguarda questa prenotazione. Inserisci anche eventuali dettagli utili che riguardano questa prenotazione, ad esempio informazioni sui bagagli, scali, ecc.'
      ">
    </app-inline-help-button>
  </mat-form-field>
</form>